import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationVersionService } from '../../../business-services/application-version.service';
import Quill from 'quill';

@Component({
  selector: 'app-add-application-version',
  templateUrl: './add-application-version.component.html',
})
export class AddApplicationVersionComponent implements OnInit {
  @Input() latestVersionNumber:string;
  addApplicationVersionForm: FormGroup;
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };
  constructor(
    private readonly activeModal : NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly toaster: ToastrService,
    private readonly ApplicationVersionService : ApplicationVersionService,
  ) { }

  ngOnInit(): void {
      this.addApplicationVersionForm = this.formBuilder.group({
        versionNumber: [null, [Validators.required]],
        releaseNote:[null,[Validators.required]],
        internalReleaseNote:[null,[Validators.required]]
      });
    }
    get cpf() {
      return this.addApplicationVersionForm.controls;
    }
    addApplicationVersion(){
      this.spinner.show();
      const viewModel = {
      versionNumber: this.cpf.versionNumber.value,
      releaseNote: this.cpf.releaseNote.value,
      internalReleaseNote: this.cpf.internalReleaseNote.value
      }
      let addModel = this.ModelMapping(viewModel);
      this.ApplicationVersionService.addApplicationVersion(addModel).then(response => {
        if (response) {
          this.spinner.hide();
          let AddedVersion = this.translate.instant("lblVersionAdded");
          this.toaster.success(AddedVersion);
          this.activeModal.close({ success: true });
        }
        else if (response.responseObject && response.responseObject.errorCount > 0) {
          this.spinner.hide();
        }
     this.spinner.hide();
      })
    }
    ModelMapping(result:any){
          let single = Object();
          single.versionNo = result.versionNumber;
          single.releaseNote = result.releaseNote;
          single.internalReleaseNote = result.internalReleaseNote;
          return single;
        }
    
    OnClose(){
      this.activeModal.close({success:false})
    }
}
